// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.previoussurveyssetup_previousSurveysSetupContainer__xXDeL {
  display: flex;
  flex:  5 1;
  flex-direction: column;
  align-items: flex-start;
  align-content: center;
  justify-content: center;
  background-color: var(--hsrcBackgroundLight);
  border-radius: 1rem;
  padding: 2rem;
}

.previoussurveyssetup_featuredItem__wFA4T {
    flex: 1 1;
    margin: 0px 20px;
    padding: 30px;
    border-radius: 10px;
    cursor:default;

  }

 
  .previoussurveyssetup_featuredDropDown__9NEOc {
    flex: 1 1;
    margin: 0px 20px;
    padding: 30px;
    border-radius: 10px;
    cursor:default;
  
  }

.previoussurveyssetup_featuredTitleHeader__4sHRv {
  color: var(--hsrcDarkBlue);
  font-size: 15px;
  font-weight: bold;
}

  /* Style the modal */
.previoussurveyssetup_modal__mQRVg {
    position: fixed; /* Stay in place */
    z-index: 1; /* Sit on top */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    background-color: rgba(0, 0, 0, 0.4); /* Semi-transparent black background */
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  /* Modal Content */
  .previoussurveyssetup_modal_content__srQP8 {
    margin: auto;
    padding: 20px;
    border: 1px solid #888;
    border-radius: 5px;
    display: flex;
    align-items: center;
    box-shadow: 0 5px 8px 0 rgba(0, 0, 0, 0.2);
    background-color: #fefefe;
  }
  
  .previoussurveyssetup_modal_text__5paLP {
    margin-left: 14px;
    font-size: 24px;
  }
  
  /* Create the circle loader with pure CSS */
  .previoussurveyssetup_loader__GnO\\+l {
    width: 50px;
    height: 50px;
    border: 8px solid #ddd;
    border-top: 8px solid #2196f3;
    border-bottom: 8px solid #2196f3;
    border-radius: 50%;
    animation: previoussurveyssetup_spin__1lSCe 2s linear infinite;
  }
  
  @keyframes previoussurveyssetup_spin__1lSCe {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  .previoussurveyssetup_printviewDialog__ub9oa {
    min-width: 90vw !important;
    max-width: 90vw !important;
  }
  
  .previoussurveyssetup_confirmDialogOverlay__y8SZX {
    z-index: 10000; 
    pointer-events: none;
  }

  .previoussurveyssetup_breadcrumbs__XX4GP{
    width: 100%;
    display: flex;
    flex: 1 1; 
    flex-direction: row;
    align-content: center;
    justify-content: flex-start;
    background-color: var(--hsrcBackgroundLight);
    padding-bottom: 4.5rem;
  }`, "",{"version":3,"sources":["webpack://./src/pages/ResearcherDashboard/components/PreviousSurveysSetup/previoussurveyssetup.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,UAAQ;EACR,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,uBAAuB;EACvB,4CAA4C;EAC5C,mBAAmB;EACnB,aAAa;AACf;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,cAAc;;EAEhB;;;EAGA;IACE,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,cAAc;;EAEhB;;AAEF;EACE,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;AACnB;;EAEE,oBAAoB;AACtB;IACI,eAAe,EAAE,kBAAkB;IACnC,UAAU,EAAE,eAAe;IAC3B,OAAO;IACP,MAAM;IACN,WAAW,EAAE,eAAe;IAC5B,YAAY,EAAE,gBAAgB;IAC9B,oCAAoC,EAAE,sCAAsC;IAC5E,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA,kBAAkB;EAClB;IACE,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,0CAA0C;IAC1C,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA,2CAA2C;EAC3C;IACE,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,6BAA6B;IAC7B,gCAAgC;IAChC,kBAAkB;IAElB,8DAAkC;EACpC;;EAWA;IACE;MACE,uBAAuB;IACzB;IACA;MACE,yBAAyB;IAC3B;EACF;;EAEA;IACE,0BAA0B;IAC1B,0BAA0B;EAC5B;;EAEA;IACE,cAAc;IACd,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,SAAO;IACP,mBAAmB;IACnB,qBAAqB;IACrB,2BAA2B;IAC3B,4CAA4C;IAC5C,sBAAsB;EACxB","sourcesContent":[".previousSurveysSetupContainer {\r\n  display: flex;\r\n  flex:  5;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  align-content: center;\r\n  justify-content: center;\r\n  background-color: var(--hsrcBackgroundLight);\r\n  border-radius: 1rem;\r\n  padding: 2rem;\r\n}\r\n\r\n.featuredItem {\r\n    flex: 1;\r\n    margin: 0px 20px;\r\n    padding: 30px;\r\n    border-radius: 10px;\r\n    cursor:default;\r\n\r\n  }\r\n\r\n \r\n  .featuredDropDown {\r\n    flex: 1;\r\n    margin: 0px 20px;\r\n    padding: 30px;\r\n    border-radius: 10px;\r\n    cursor:default;\r\n  \r\n  }\r\n\r\n.featuredTitleHeader {\r\n  color: var(--hsrcDarkBlue);\r\n  font-size: 15px;\r\n  font-weight: bold;\r\n}\r\n\r\n  /* Style the modal */\r\n.modal {\r\n    position: fixed; /* Stay in place */\r\n    z-index: 1; /* Sit on top */\r\n    left: 0;\r\n    top: 0;\r\n    width: 100%; /* Full width */\r\n    height: 100%; /* Full height */\r\n    background-color: rgba(0, 0, 0, 0.4); /* Semi-transparent black background */\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n  \r\n  /* Modal Content */\r\n  .modal_content {\r\n    margin: auto;\r\n    padding: 20px;\r\n    border: 1px solid #888;\r\n    border-radius: 5px;\r\n    display: flex;\r\n    align-items: center;\r\n    box-shadow: 0 5px 8px 0 rgba(0, 0, 0, 0.2);\r\n    background-color: #fefefe;\r\n  }\r\n  \r\n  .modal_text {\r\n    margin-left: 14px;\r\n    font-size: 24px;\r\n  }\r\n  \r\n  /* Create the circle loader with pure CSS */\r\n  .loader {\r\n    width: 50px;\r\n    height: 50px;\r\n    border: 8px solid #ddd;\r\n    border-top: 8px solid #2196f3;\r\n    border-bottom: 8px solid #2196f3;\r\n    border-radius: 50%;\r\n    -webkit-animation: spin 2s linear infinite;\r\n    animation: spin 2s linear infinite;\r\n  }\r\n  \r\n  @-webkit-keyframes spin {\r\n    0% {\r\n      -webkit-transform: rotate(0deg);\r\n    }\r\n    100% {\r\n      -webkit-transform: rotate(360deg);\r\n    }\r\n  }\r\n  \r\n  @keyframes spin {\r\n    0% {\r\n      transform: rotate(0deg);\r\n    }\r\n    100% {\r\n      transform: rotate(360deg);\r\n    }\r\n  }\r\n\r\n  .printviewDialog {\r\n    min-width: 90vw !important;\r\n    max-width: 90vw !important;\r\n  }\r\n  \r\n  .confirmDialogOverlay {\r\n    z-index: 10000; \r\n    pointer-events: none;\r\n  }\r\n\r\n  .breadcrumbs{\r\n    width: 100%;\r\n    display: flex;\r\n    flex: 1; \r\n    flex-direction: row;\r\n    align-content: center;\r\n    justify-content: flex-start;\r\n    background-color: var(--hsrcBackgroundLight);\r\n    padding-bottom: 4.5rem;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"previousSurveysSetupContainer": `previoussurveyssetup_previousSurveysSetupContainer__xXDeL`,
	"featuredItem": `previoussurveyssetup_featuredItem__wFA4T`,
	"featuredDropDown": `previoussurveyssetup_featuredDropDown__9NEOc`,
	"featuredTitleHeader": `previoussurveyssetup_featuredTitleHeader__4sHRv`,
	"modal": `previoussurveyssetup_modal__mQRVg`,
	"modal_content": `previoussurveyssetup_modal_content__srQP8`,
	"modal_text": `previoussurveyssetup_modal_text__5paLP`,
	"loader": `previoussurveyssetup_loader__GnO+l`,
	"spin": `previoussurveyssetup_spin__1lSCe`,
	"printviewDialog": `previoussurveyssetup_printviewDialog__ub9oa`,
	"confirmDialogOverlay": `previoussurveyssetup_confirmDialogOverlay__y8SZX`,
	"breadcrumbs": `previoussurveyssetup_breadcrumbs__XX4GP`
};
export default ___CSS_LOADER_EXPORT___;
